<div class="app__discovery--widget--container">
  <div class="app__discovery--inner--section mt-8">
    <div class="app__centered-item app__solid--border w-full h-auto bg-white border-[#53565b38] rounded-xl px-6 py-8">
      <div>
        <p class="app__sub-title text-[#53565B] font-semibold" [innerHTML]="innerContent?.title"></p>
        <p class="app__sub-title text-[#18191C] text-sm mt-4 mb-7" [innerHTML]="innerContent?.subTitle"></p>
        @if (formImage && text && data.action_type != 'status_upload_2' && data.action_type != 'status_upload_1') {
          <div  style="margin: auto !important;" class="app__discovery--rectangular--options items-start w-[120px] h-[120px] sm:w-[108px] sm:h-[100px] border-solid border px-1">
            <div class="mt-4">
              <span class="app__centered-item"
                ><img [src]="formImage" width="32px" height="32px"
              /></span>
              <p class="paragraph__medium text-[12px] sm:text-[12px] leading-[18px] mt-1">{{ text }}</p>
            </div>
          </div>
        }
        @if (!formImage && !text && text && data.action_type != 'status_upload_2' && data.action_type != 'status_upload_1') {
          <div class="loader-container m-0"  >
            <div class="flex loader-body"  style="width: 108px;margin: auto;">
              <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
                <div class="ph-col-12" style="padding: 0px !important">
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="app__centered-item mt-12">
          <app-button-slide (isSubmitButtonActiveForSubMit)="submitAllFormAnswers($event)"></app-button-slide>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
<div class="flex items-start justify-between w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
  <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
    <span class="app__centered-item gap-2 text-[#18191C]"
      ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
      >
    </button>
    <div class="w-[158px]">
      <button
        class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
        type="submit"
        (click)="isFlowMarkedCompleted ? updateOnboardingChecklist() : handleSteps('forward')"
        >
        Continue
      </button>
    </div>
  </div>
